<template>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Email Templates</div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="px-4 py-3">
          <!-- Invoice Template Override Section -->
          <div class="mt-2">
            <div class="text-right mb-2" v-if="editingInvoice">
              <button type="button" class="btn btn-sm btn-primary" @click="saveInvoiceTemplate">
                <span>Save Template</span>
              </button>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mr-2"
              @click="toggleEditInvoice"
            >
              <span>{{ editingInvoice ? 'Cancel' : 'Edit' }}</span>
            </button>
            Invoice Template Override
            
            <div v-if="editingInvoice" class="mt-3 mb-4">
              <div class="form-group">
                <label class="font-weight-bold">Email Template</label>
                <small class="text-muted d-block mb-2">Compose your email naturally. Use [client] as a placeholder for the recipient's name. Separate paragraphs with a blank line.</small>
                <textarea v-model="invoiceTemplate" class="form-control" rows="12"></textarea>
              </div>
              
              <div class="alert alert-info">
                <strong>Preview:</strong>
                <div class="mt-2 p-3 bg-white border rounded" style="font-family: 'Times New Roman', serif; line-height: 1.6;" v-html="generatePreview()"></div>
              </div>
            </div>
          </div>
          <hr />
          
          <div class="mt-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mr-2"
              v-on:click="viewConsentEmail()"
            >
              <span>View</span>
            </button>
            Email consent
          </div>
          <hr />
          <div class="mt-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mr-2"
              v-on:click="viewDiscloseFeeSchedule()"
            >
              <span>View</span>
            </button>
            Disclose fee schedule in effect
          </div>
          <hr />
          <div class="mt-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mr-2"
              v-on:click="viewUpdatedFeeSchedule()"
            >
              <span>View</span>
            </button>
            Updated fee schedule
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-button {
  width: 80px;
}
.modal-title {
  height: 24px;
  display: flex;
  align-items: center;
  margin-left: 16px;

  font-weight: bold;
  font-size: 17px;
  line-height: 20px;
  color: #616466;
}

.modal-body {
  min-height: 50vh;
}
</style>

<script>
import IconButton from "../../component/icon-button.vue";
import { Modal } from "../../factory";
import { Api } from "../../factory";
import { session } from "../../service";

export default {
  components: { IconButton },
  data() {
    return {
      editingInvoice: false,
      invoiceTemplate: ''
    }
  },
  methods: {
    generateHtmlTemplate() {
      if (!this.invoiceTemplate.trim()) {
        return '<div style="padding: 1rem 1.5rem"></div>';
      }
      
      // Split by blank lines (double newlines or more)
      const paragraphs = this.invoiceTemplate
        .split(/\n\s*\n+/)
        .map(p => p.trim())
        .filter(p => p)
        .map(p => `<p>${p}</p>`)
        .join('\n  ');
      
      return `<div style="padding: 1rem 1.5rem">
  ${paragraphs}
</div>`;
    },
    generatePreview() {
      const template = this.generateHtmlTemplate();
      return template.replace(/\[client\]/gi, 'John Doe');
    },
    parseHtmlToFields(html) {
      // Extract text from HTML paragraphs
      if (!html) {
        this.invoiceTemplate = '';
        return;
      }
      
      // Create a temporary element to parse HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const paragraphs = tempDiv.querySelectorAll('p');
      
      // Join paragraphs with double newlines to recreate the original format
      const textContent = Array.from(paragraphs)
        .map(p => p.textContent)
        .join('\n\n');
      
      this.invoiceTemplate = textContent;
    },
    toggleEditInvoice() {
      const { firm } = session.get("state");
      const currentTemplate = firm.emailTemplates?.invoice || '';
      this.parseHtmlToFields(currentTemplate);
      this.editingInvoice = !this.editingInvoice;
    },
    async saveInvoiceTemplate() {
      try {
        const { firm } = session.get("state");
        
        // Generate HTML from template text
        const htmlTemplate = this.generateHtmlTemplate();
        
        // Update local state
        firm.emailTemplates = firm.emailTemplates || {};
        firm.emailTemplates.invoice = htmlTemplate;
        
        // Send to update the database
        await Api.put(`/firms/${firm._id}`, firm);
        
        // Update session global
        session.set("state", { ...session.get("state"), firm });
        this.editingInvoice = false;
      } catch (error) {
        console.error('Error saving template:', error);
        alert('Error saving template. Please try again.');
      }
    },
    viewDiscloseFeeSchedule() {
      Modal.open("DiscloseFeeSchedule", {
        inEffect: true,
        methods: {
          back: () => { Modal.open("EmailTemplates") },
          send: () => { Modal.open("EmailTemplates") }
        }
      })
    },
    viewUpdatedFeeSchedule() {
      Modal.open("DiscloseFeeSchedule", {
        updated: true,
        methods: {
          back: () => { Modal.open("EmailTemplates") },
          send: () => { Modal.open("EmailTemplates") }
        }
      })
    },
    viewConsentEmail() {
      Modal.open("EmailConsent", {
        methods: {
          back: () => { Modal.open("EmailTemplates") },
          send: () => { Modal.open("EmailTemplates") }
        },
      })
    }
  }
};
</script>
